const POPUP_RECORD_TYPES = {
  HAS_VIEW_RANK_SETTING: 'HAS_VIEW_RANK_SETTING',
};

export {POPUP_RECORD_TYPES};
